import { callProcedure } from 'clickNgo/helpers/api'
import { NotificationController } from 'core-components/library/popup'

export interface ISaveWelcomeFlowDataParams {
  role?: string | null
  manager?: string | null
  rtm?: string | null
  businessUnit?: string | null
  notMyPartners?: string | null
}

export const saveWelcomeFlowData = async (params: Partial<ISaveWelcomeFlowDataParams> = {}) => {
  try {
    const response = await callProcedure({
      url: '/webservice/621/sp/v3/spJBPMyPartnersSave/call',
      method: 'POST',
      data: {
        'p.Role': params.role ?? null,
        'p.Manager': params.manager ?? null,
        'p.RTM': params.rtm ?? null,
        'p.BusinessUnit': params.businessUnit ?? null,
        'p.NotMyPartners': params.notMyPartners ?? null,
      },
    })

    return params
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : 'Failed to save welcome flow data'
    NotificationController.showError({
      message: errorMessage,
    })

    throw e
  }
}
